// extracted by mini-css-extract-plugin
export default {"video-wrapper":"VideoSlide_video-wrapper__P-ZB6"};